import { prizmNext } from '4ff-lib-foundation/lib/components/themes/prizmNext';

const { colors: { palette } } = prizmNext;

export default {
  lpbDashboard: {
    filterPanel: {
      containerPadding: '0 16px',
      linksAligment: 'center',
    },
    tile: {
      boxShadow: '0px 0px 1px 0px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.15)',
      boxShadowHover: '0 8px 16px 0 rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.15)',
    },
    colors: {
      bg: palette.neutral.white100,
      tileOverlayBg: palette.primary.primary70,
      tileOverlayLink: palette.primary.primary80,
      tileAbbrText: palette.primary.primary30,
      filterBg: palette.neutral.white100,
      filterLinkActive: palette.primary.primary40,
      filterBorder: palette.surface.surface1,
      filterLinkColor: palette.variant.variant50,
      filterArrowsBg: palette.neutral.white100,
      filterArrowColor: palette.neutral.neutral20,
      fallbackMsgColor: palette.neutral.neutral10,
      pageNotFoundBg: palette.variant.variant95,
      tileArrowsBg: palette.neutral.white100,
      tileLinkBg: palette.neutral.white100,
      tileImgBoxBg: palette.primary.primary99,
      tileImgBoxBorder: palette.primary.primary99,
      tileTitleColor: palette.neutral.neutral30,
      tileDescriptionColor: palette.variant.variant40,
    },
  },
};
